export function formatAddressErrors(errors: Record<string, string>): Record<string, string> {
  const result = { ...errors }

  if (errors['street']) result['street'] = 'Vul een straat in'
  if (errors['houseNumber']) result['houseNumber'] = 'Vul een huisnummer in'
  if (errors['city']) result['city'] = 'Vul een plaats in'
  if (errors['country']) result['country'] = 'Gebruik een landcode van 2 of 3 letters'

  if (errors['postalCode']) {
    result['postalCode'] = errors['postalCode'].includes('must match')
      ? 'Ongeldige postcode (bijv. 1234 AB)'
      : 'Vul een postcode in'
  }

  return result
}
